/* people : les écrans « Personnes » et la modification d’un client (W3,
 * 2026-09-30). Mêmes clés que en/people.ts. */
export default {
  people: {
    title: 'Personnes',
    subtitle:
      'Tous ceux qui peuvent se connecter à l’espace du cabinet, et ce que chacun peut voir.',
    add: 'Ajouter une personne',
    back: 'Retour aux personnes',
    emptyTitle: 'Personne pour le moment',
    empty: 'Ajoutez un collègue, ou une personne chez un client qui doit suivre ses dossiers.',
    group: {
      firm_main: 'Compte principal',
      firm_manager: 'Avocats du cabinet',
      client_viewer: 'Personnes chez les clients',
    },
    groupSub: {
      firm_main: 'Voit et modifie tout, et est le seul à pouvoir ajouter des personnes.',
      firm_manager: 'Travaillent sur les clients et les marques qui leur sont confiés.',
      client_viewer:
        'Lisent les dossiers ouverts de leur propre société. Ils ne voient jamais les correspondances.',
    },
  },

  person: {
    newTitle: 'Nouvelle personne',
    newSub:
      'Choisissez qui est cette personne et ce qu’elle peut voir. Vous décidez à part de lui envoyer une invitation maintenant.',
    kind: {
      firm_main: 'Compte principal',
      firm_manager: 'Avocat du cabinet',
      client_viewer: 'Personne chez un client',
    },
    kindHint: {
      firm_manager:
        'Peut travailler sur les clients et les marques que vous lui confiez : correspondances, dossiers, documents.',
      client_viewer:
        'Peut seulement lire les dossiers ouverts des sociétés que vous lui confiez. Ne peut rien modifier.',
    },
    role: {
      senior_partner: 'Associé principal',
      partner: 'Associé',
      senior_associate: 'Collaborateur senior',
      counsel: 'Conseil',
      associate: 'Collaborateur',
    },
    status: {
      off: 'Désactivé',
      notInvited: 'Aucune invitation',
      invited: 'Invitation du {date}',
      expired: 'Invitation expirée',
    },
    form: {
      title: 'Qui est-ce',
      sub: 'Son nom tel que les collègues le verront, et la langue de ses e-mails.',
      kind: 'Type de compte',
      name: 'Nom complet',
      nameRequired: 'Saisissez le nom',
      email: 'Adresse e-mail',
      emailInvalid: 'Saisissez une adresse e-mail valide',
      emailHint: 'Cette adresse sert à se connecter. Elle ne peut pas être changée ensuite.',
      role: 'Fonction au cabinet',
      noRole: 'Non précisée',
      language: 'Langue',
      languageDefault: 'Non choisie (anglais)',
      languageHint: 'Pour ses e-mails. La personne peut la changer elle-même après connexion.',
    },
    access: {
      title: 'Ce que la personne peut voir',
      sub: {
        firm_manager:
          'Des sociétés entières, ou seulement certaines marques d’une société. Rien d’autre ne lui est visible.',
        client_viewer:
          'Les sociétés dont elle peut lire les dossiers ouverts. Il en faut au moins une.',
      },
      whole: 'Toute la société',
      some: 'Seulement certaines marques',
      howMuch: 'Quelle part de cette société',
      noMarks: 'Cette société n’a pas encore de marques.',
      chooseMarks: 'Choisissez au moins une marque, ou donnez toute la société.',
      search: 'Trouver une société cliente à ajouter…',
      dropPending: 'Ne pas ajouter {name}',
      viewerNeedsOne: 'Ajoutez au moins une société : sans elle, la personne ne verrait rien.',
      give: 'Donner cet accès',
      given: 'Accès donné',
      remove: 'Retirer',
      removeTitle: 'Retirer l’accès à {what} ?',
      removeBody: 'La personne cesse de le voir immédiatement. Rien d’autre ne change.',
      noneYet: 'La personne ne voit encore rien. Ajoutez une société ci-dessous.',
      mainSeesAll: 'Le compte principal voit tout le cabinet. Il n’y a rien à choisir.',
      wholeFirm: 'Tout le cabinet',
      none: 'Rien pour l’instant',
      clients: '{n} société | {n} sociétés',
      someMarks: '{name} : {n} marque | {name} : {n} marques',
    },
    invite: {
      title: 'Invitation',
      sub: 'Un e-mail avec un lien pour choisir un mot de passe. Le lien fonctionne une fois, pendant 7 jours.',
      now: 'Envoyer une invitation par e-mail maintenant',
      send: 'Envoyer l’invitation',
      again: 'Envoyer une nouvelle invitation',
      confirmTitle: 'Envoyer une invitation à {email} ?',
      body: 'La personne reçoit un lien pour choisir un mot de passe et se connecter.',
      replaces:
        'La personne reçoit un nouveau lien pour choisir un mot de passe. Le lien envoyé plus tôt ne fonctionne plus.',
      sent: 'Envoyée à {email}.',
      done: 'Invitation envoyée',
      failed: 'L’invitation n’a pas été envoyée',
      hasPassword:
        'La personne a un mot de passe et peut se connecter. Une nouvelle invitation lui permet d’en choisir un autre.',
      waiting: 'Invitation envoyée le {sent}. Le lien fonctionne jusqu’au {until}.',
      lapsed: 'Invitation envoyée le {sent}, mais le lien a expiré sans être utilisé.',
      never: 'Aucune invitation envoyée : sans elle, la personne ne peut pas se connecter.',
    },
    account: {
      title: 'Son compte',
      sub: 'Désactiver conserve tout ce que la personne a fait ; supprimer retire le compte lui-même.',
    },
    off: {
      action: 'Désactiver',
      undo: 'Réactiver',
      confirmTitle: 'Désactiver {name} ?',
      body: 'La personne est déconnectée et ne peut plus se connecter tant que vous ne la réactivez pas. Ce qu’elle a fait reste.',
    },
    delete: {
      action: 'Supprimer',
      confirmTitle: 'Supprimer {name} ?',
      body: 'Le compte et ses accès sont retirés et ne peuvent pas être restaurés. Les dossiers qui lui étaient attribués n’ont plus de responsable ; la trace de ce qu’elle a fait reste.',
      done: 'Compte de {name} supprimé',
    },
    create: 'Ajouter la personne',
    save: 'Enregistrer',
    saved: 'Enregistré',
    created: 'Personne ajoutée',
    createdSub: 'Aucun e-mail n’a été envoyé. Envoyez l’invitation quand vous le souhaitez.',
    createdNoInvite: 'Personne ajoutée, mais l’invitation n’a pas été envoyée',
    failed: 'Cela n’a pas fonctionné',
    emailTaken: 'Un compte existe déjà avec cette adresse e-mail.',
    summary: 'En bref',
  },

  editClient: {
    crumb: 'Modifier',
    title: 'Modifier le client',
    subtitle:
      'Modifiez ce qui est enregistré pour {name}. Seuls les champs modifiés sont enregistrés.',
    save: 'Enregistrer les modifications',
    saving: 'Enregistrement…',
    saved: 'Modifications enregistrées',
    failed: 'Les modifications n’ont pas été enregistrées',
    notSaved:
      'Rien n’est enregistré tant que vous n’appuyez pas sur « Enregistrer les modifications ».',
    delete: {
      title: 'Supprimer ce client',
      sub: 'Retire la société avec sa {n} marque, ses documents et ses correspondances, et l’accès de chacun à la société. | Retire la société avec ses {n} marques, leurs documents et leurs correspondances, et l’accès de chacun à la société.',
      action: 'Supprimer le client',
      confirmTitle: 'Supprimer {name} ?',
      body: 'Sa {n} marque, ses documents et ses correspondances, et l’accès de chacun à la société sont retirés. C’est irréversible. | Ses {n} marques, leurs documents et leurs correspondances, et l’accès de chacun à la société sont retirés. C’est irréversible.',
      done: 'Client {name} supprimé',
      failed: 'Le client n’a pas été supprimé',
      hasCases:
        'Ce client a des dossiers d’opposition. Supprimez-les d’abord, sur la page Oppositions.',
    },
  },
}
